import { motion, useInView } from 'framer-motion';
import { useRef } from 'react';

const metrics = [
  { value: '30+', label: 'Currencies' },
  { value: '60+', label: 'Global Counterparties' },
  { value: '3', label: 'Regulatory Licences' },
  { value: '24/7', label: 'Platform Uptime' }
];

export const TrustMetrics = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-100px" });

  return (
    <section 
      className="py-16 lg:py-20 bg-white border-t border-[#E5E7EB]"
      data-testid="trust-metrics-section"
    >
      <div className="section-container">
        <div 
          ref={ref}
          className="grid grid-cols-2 lg:grid-cols-4 border-t border-l border-[#E5E7EB]"
          data-testid="trust-metrics-grid"
        >
          {metrics.map((metric, index) => (
            <motion.div
              key={metric.label}
              initial={{ opacity: 0, y: 20 }}
              animate={isInView ? { opacity: 1, y: 0 } : {}}
              transition={{ 
                duration: 0.6, 
                delay: index * 0.1, 
                ease: [0.22, 1, 0.36, 1] 
              }}
              className="p-8 lg:p-12 border-r border-b border-[#E5E7EB] text-center"
              data-testid={`metric-${index}`}
            >
              <div className="text-5xl sm:text-6xl lg:text-7xl xl:text-8xl font-semibold tracking-tight text-[#4FB3DF] mb-4">
                {metric.value}
              </div>
              <div className="text-base text-[#6B7280] font-semibold tracking-wide">
                {metric.label}
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
